export default __webpack_public_path__ + "static/logo_dark-935ff0c73225a24ff0b76b74f8317d5e.svg";